import React, { useEffect } from 'react';
import SuccessScreen from '../../components/endResultStage/SuccessScreen';
import { useSettings } from '../../hooks/queryHooks';
import { useStepsState } from '../../hooks/zustandHooks';

const ConnectionSuccessPage = () => {
  const { settings } = useSettings();
  const isAddAnotherAccountDisabled = settings?.isAddAnotherAccountDisabled ?? false;
  const setActiveStep = useStepsState(state => state.setActiveStep);

  useEffect(() => {
    setActiveStep({ stepIndex: 2 });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <SuccessScreen isAddAnotherAccountDisabled={isAddAnotherAccountDisabled} />;
};

export { ConnectionSuccessPage };
export default ConnectionSuccessPage;
